/* eslint-disable */
// GENERATED FILE - DO NOT EDIT
import React, { SVGProps } from "react";

const SvgCustomerServices = (props: SVGProps<SVGSVGElement>) => (
  <svg width={22.89} viewBox="0 0 22.89 33.789" {...props}>
    <g data-name="Customer Services">
      <path
        data-name="Path 69"
        d="M14.413 21.053v1l-2.969 2.194-2.969-2.194v-.974a6.91 6.91 0 002.454.447h.958a6.905 6.905 0 002.526-.473z"
        fill="#ffe5c2"
      />
      <path
        data-name="Path 70"
        d="M4.001 4.422v10.179a6.928 6.928 0 006.928 6.928h.958a6.928 6.928 0 006.928-6.928V4.422z"
        fill="#fed2a4"
      />
      <path
        data-name="Path 71"
        d="M4.001 4.422V14.6a6.928 6.928 0 006.928 6.928h.958a6.9 6.9 0 001.5-.164A6.929 6.929 0 017.96 14.6v-3.466a.991.991 0 011.295-.941 9.135 9.135 0 002.745.422h1.409a8.638 8.638 0 005.406-1.859V4.422z"
        fill="#ffbd86"
      />
      <g data-name="Group 12" fill="#f9f9fb">
        <path
          data-name="Path 72"
          d="M11.444 24.249l-2.925 2.21-2.383-3.648 1.419-1.433z"
        />
        <path
          data-name="Path 73"
          d="M11.444 24.249l2.925 2.21 2.383-3.648-1.419-1.433z"
        />
        <path
          data-name="Path 74"
          d="M6.135 22.811l-3.192 1.885a4.982 4.982 0 00-2.449 4.29v4.8h21.9v-4.8a4.982 4.982 0 00-2.449-4.29l-3.193-1.885-2.383 3.648-2.925-2.21-2.926 2.212z"
        />
      </g>
      <path
        data-name="Path 75"
        d="M17.607 23.315l-2.717 4.159a.462.462 0 01-.665.116l-2.78-2.1-2.78 2.1A.462.462 0 018 27.474l-2.717-4.159.853-.5 2.383 3.648 2.926-2.21 2.926 2.21 2.383-3.648z"
        fill="#e8edf2"
      />
      <path
        data-name="Path 76"
        d="M12.472 25.026v1.24l-1.028-.776-1.028.776v-1.24l1.028-.777z"
        fill="#5f99d7"
      />
      <path
        data-name="Path 77"
        d="M6.136 22.811l.551.843-1.764 1.041a4.983 4.983 0 00-2.448 4.29v4.8H.495v-4.8a4.983 4.983 0 012.448-4.29z"
        fill="#e8edf2"
      />
      <path
        data-name="Path 78"
        d="M12.473 27.083h-2.056v-2.058l1.028-.776 1.028.776z"
        fill="#ffcd27"
      />
      <path
        data-name="Path 79"
        d="M12.472 25.026v1.24l-1.028-.776-1.028.776v-1.24l1.028-.777z"
        fill="#ebb400"
      />
      <path
        data-name="Path 80"
        d="M9.923 33.783l.493-6.7h2.058l.493 6.7z"
        fill="#ffcd27"
      />
      <path
        data-name="Path 81"
        d="M19.342 7.937h-.527v6.114h.527a2.859 2.859 0 002.859-2.859v-.4a2.859 2.859 0 00-2.859-2.855z"
        fill="#12b05e"
      />
      <path
        data-name="Path 82"
        d="M17.474 19.014h-2.257a.99.99 0 01-.99-.99v-.137a.99.99 0 01.99-.99h2.254a.99.99 0 01.99.99v.137a.99.99 0 01-.987.99z"
        fill="#12b05e"
      />
      <path
        data-name="Path 83"
        d="M7.916.495a3.914 3.914 0 00-3.913 3.836A2.28 2.28 0 001.744 6.61v6.548a4.762 4.762 0 004.762-4.762V6.774a8.93 8.93 0 005.491 1.861h1.409a8.64 8.64 0 005.406-1.859c1.918-2 2.328-3.338 2.328-5.287V.495z"
        fill="#3e5564"
      />
      <path
        data-name="Path 84"
        d="M10.742.495a3.914 3.914 0 00-3.913 3.836A2.28 2.28 0 004.57 6.61v5.622a4.736 4.736 0 01-2.822.926V6.61a2.28 2.28 0 012.259-2.279A3.914 3.914 0 017.917.495z"
        fill="#344b5a"
      />
      <g data-name="Group 13">
        <path
          data-name="Path 85"
          d="M5.004 28.095a.495.495 0 10-.835.532l.339.532a1.968 1.968 0 01.308 1.058v3.078a.495.495 0 10.99 0v-3.078a2.956 2.956 0 00-.463-1.59z"
        />
        <path
          data-name="Path 86"
          d="M20.198 24.27l-3.137-1.852-1.374-1.388a.53.53 0 00-.035-.032 7.461 7.461 0 001.8-1.49h.018a1.487 1.487 0 001.435-1.1h.753a3.038 3.038 0 003.035-3.035V10.8a3.358 3.358 0 00-3.354-3.354h-.032v-.47A10.887 10.887 0 0020.698 5.2a.495.495 0 10-.847-.513A10.238 10.238 0 0118.48 6.41a8.156 8.156 0 01-5.071 1.73H12a8.388 8.388 0 01-5.184-1.755.508.508 0 00-.311-.106.5.5 0 00-.495.495V8.4a4.27 4.27 0 01-2.243 3.757 4.22 4.22 0 01-1.449.471l-.077.01V6.61a1.79 1.79 0 011.765-1.784.5.5 0 00.495-.487A3.437 3.437 0 017.916.99h12.732v.5a8.327 8.327 0 01-.078 1.224.495.495 0 10.979.144 9.412 9.412 0 00.088-1.368V.495A.5.5 0 0021.143 0H7.916a4.409 4.409 0 00-4.377 3.878 2.786 2.786 0 00-2.29 2.732v6.548a.5.5 0 00.495.495 5.343 5.343 0 00.7-.047 5.232 5.232 0 001.06-.258V14.6a7.427 7.427 0 00.231 1.845.495.495 0 10.959-.246 6.435 6.435 0 01-.2-1.6v-1.725a5.255 5.255 0 002.5-4.478v-.674a9.48 9.48 0 005 1.408h1.409a9.238 9.238 0 004.911-1.4v6.87a6.413 6.413 0 01-.288 1.911 1.476 1.476 0 00-.558-.109h-2.246a1.487 1.487 0 00-1.485 1.485v.137a1.487 1.487 0 001.485 1.485h.824a6.447 6.447 0 01-1.8 1.078 6.982 6.982 0 01-2.359.447h-.958a6.422 6.422 0 01-5.33-2.834.495.495 0 10-.82.555 7.4 7.4 0 002.43 2.268l-.006.005-1.374 1.387-3.137 1.855A5.5 5.5 0 000 28.986v4.308a.495.495 0 10.99 0v-4.308a4.505 4.505 0 012.206-3.864l2.785-1.645 2.125 3.252a.5.5 0 00.329.217.5.5 0 00.383-.093l1.1-.834v1.049l-.456 6.184a.5.5 0 00.457.53h.037a.5.5 0 00.493-.459l.424-5.748h1.135l.075 1.015a.495.495 0 10.987-.073l-.107-1.451V26.02l1.1.834a.5.5 0 00.3.1.506.506 0 00.414-.224l2.125-3.252 2.785 1.645a4.505 4.505 0 012.206 3.864v4.308a.495.495 0 00.99 0v-4.309a5.5 5.5 0 00-2.693-4.716zm-.535-6.855h-.781a1.479 1.479 0 00-.062-.155 7.381 7.381 0 00.491-2.659v-.054h.032a3.343 3.343 0 002.364-.977v1.8a2.047 2.047 0 01-2.045 2.044zm-.32-8.982a2.367 2.367 0 012.364 2.364v.4a2.367 2.367 0 01-2.364 2.364h-.032V8.432h.032zm-4.621 9.591v-.137a.5.5 0 01.495-.495h2.254a.5.5 0 01.495.495v.137a.5.5 0 01-.495.495h-2.249a.5.5 0 01-.5-.495zm-5.316 3.843a7.3 7.3 0 001.52.156h.958a7.366 7.366 0 002.085-.3h.01l.087-.026-2.625 1.937-2.577-1.9.059.017c.167.044.33.084.486.116zm-.765 3.878l-1.875-2.87.836-.844 3.02 2.223-.5.377zm3.334.843h-1.063v-1.316l.533-.4.533.4zm2.268-.843l-1.471-1.114-.5-.377 3.012-2.223.836.844z"
        />
        <path
          data-name="Path 87"
          d="M18.57 27.943a.5.5 0 00-.683.152l-.339.532a2.955 2.955 0 00-.463 1.59v3.078a.495.495 0 10.99 0v-3.078a1.968 1.968 0 01.308-1.058l.343-.532a.5.5 0 00-.156-.684z"
        />
        <path
          data-name="Path 88"
          d="M13.233 30.676a.495.495 0 00-.987.073l.19 2.576a.5.5 0 00.493.459h.037a.5.5 0 00.457-.53z"
        />
        <path
          data-name="Path 89"
          d="M11.423 17.715h.02a2.665 2.665 0 002.238-1.169.495.495 0 00-.829-.542 1.68 1.68 0 01-1.416.72 1.731 1.731 0 01-1.475-.726.495.495 0 10-.822.552 2.722 2.722 0 002.284 1.165z"
        />
        <path
          data-name="Path 90"
          d="M8.746 12.525v-1.058a.495.495 0 10-.99 0v1.058a.495.495 0 10.99 0z"
        />
        <path
          data-name="Path 91"
          d="M14.566 13.017a.5.5 0 00.495-.495v-1.055a.495.495 0 00-.99 0v1.058a.5.5 0 00.495.492z"
        />
      </g>
    </g>
  </svg>
);

SvgCustomerServices.defaultProps = {};
export default SvgCustomerServices;
/* eslint-enable */
